import React from "react";
import { useSelector } from "react-redux";
import { ContextLanguage } from "../../context/Context.Language";
import { STATE_CONSTANTS_PROFILE } from "../../utils/useConstantState";
import ProfileBeforeLogin from "./render/Profile.BeforeLogin";
import ProfileLogin from "./render/Profile.Login";
import { useNavigate } from "react-router-dom";

const ProfileMain = () => {
  const navigate = useNavigate();
  const [tab, setTab] = React.useState(STATE_CONSTANTS_PROFILE.LOGIN);

  const { user } = useSelector((state) => state.auth);

  React.useEffect(() => {
    const isNew = sessionStorage.getItem("create-new");

    if (isNew === "true") {
      sessionStorage.removeItem("create-new");
      navigate("/OurServices");
    } else if (user?._id) {
      setTab(STATE_CONSTANTS_PROFILE.PROFILE);
    } else {
      return;
    }
  }, [user]);

  // if (tab === STATE_CONSTANTS_PROFILE.LOGIN) {
  //   return <ProfileLogin language={language} setTab={setTab} />;
  // } else if (tab === STATE_CONSTANTS_PROFILE.CURRENT) {

  if (tab === STATE_CONSTANTS_PROFILE.LOGIN) {
    return <ProfileBeforeLogin setTab={setTab} />;
  } else if (tab === STATE_CONSTANTS_PROFILE.PROFILE) {
    return <ProfileLogin />;
  } else {
    return <ProfileBeforeLogin />;
  }

  // } else {
  //   return <ProfileLogin setTab={setTab} />;
  // }
};

export default ProfileMain;
